import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Center,
  Flex,
  IconButton,
  Stack,
  Text
} from '@chakra-ui/react'
import { ArrowIcon } from 'assets/icons'
import { motion, useAnimationControls } from 'framer-motion'
import { setProfileItemId, usersSelectors } from 'store'
import { PENDING, SUCCEEDED, REJECTED } from 'utils/constants'
import { COLORS } from 'utils/styles'

import { RequestContent } from './RequestContent'

export const ConnectRequestModal = ({
  handleNotificationButton,
  selectId,
  requestId,
  isNotifProfileDisplayed,
  setIsNotifProfileDisplayed,
  getProfileItemStatus,
  friendRequestID
}) => {
  const {
    profileItem, profileItemId, acceptFriendStatus, denyFriendStatus
  } = useSelector(usersSelectors)
  const dispatch = useDispatch()
  const controls = useAnimationControls()

  const handleCloseRequestModal = () => {
    localStorage.setItem('isRequestModalOpen', 'false')
    dispatch(setProfileItemId(null))
    setIsNotifProfileDisplayed(false)
    localStorage.removeItem('id')
  }

  // Profile Popup Animation
  useEffect(() => {
    // console.log('hmm?')
    if (profileItem && profileItemId) {
      // for opening the profile
      controls.start({
        x: 0,
        transition: {
          ease: [0, 0, 0.2, 1],
          duration: 0.2
        }
      })
    } else if (!profileItemId) {
      // closing the profile
      controls.start({
        x: '100%',
        transition: {
          ease: [0, 0, 0.2, 1],
          duration: 0.2
        }
      })
    }
  }, [isNotifProfileDisplayed, getProfileItemStatus, profileItem])

  return (
    <Box
      as={motion.div}
      animate={controls}
      initial={{ x: '100%' }}
      top="0"
      left={0}
      zIndex={5}
      height="1148px"
      width="100%"
      position="absolute"
      backgroundColor="white"
      gap={5}
    >
      <Stack width="100%" height="40px" backgroundColor={COLORS.gold} position="sticky">
        <Flex>
          <Box width="95%">
            <Center>
              <Text paddingY={1} fontWeight={700}>Connection Request</Text>
            </Center>
          </Box>
          <Box>
            <IconButton
              _hover={{ background: COLORS.gold_hover }}
              background="unset"
              transform="rotate(180deg)"
              icon={<ArrowIcon />}
              onClick={() => handleCloseRequestModal()}
              id="back-button"
            />
          </Box>
        </Flex>
      </Stack>

      <RequestContent
        getProfileItemStatus={getProfileItemStatus}
        profileItem={profileItem}
        handleNotificationButton={handleNotificationButton}
        requestId={requestId}
        friendRequestID={friendRequestID}
        isAcceptLoading={acceptFriendStatus === PENDING}
        isRejectLoading={denyFriendStatus === PENDING}
      />

    </Box>
  )
}
